import { createContext } from 'react';
import { MarketingCampaignWithSource } from '../../types/marketing';
import { Optional } from '../../types/global';

export type CampaignEditorPayload = {
  campaign?: Optional<MarketingCampaignWithSource, 'id'> | null;
  offboardingContext?: { offboardingId: string; employeeName: string };
};

export interface CampaignEditorContextValue {
  open: (payload: CampaignEditorPayload) => void;
}

export const CampaignEditorContext =
  createContext<CampaignEditorContextValue | null>(null);
